export default __webpack_public_path__ + "static/media/io.4b77b61b.svg";